import { styled } from '@mui/material';
import { animated } from '@react-spring/web';

export const NotificationToastContainer = styled(animated.div)(() => ({
  pointerEvents: 'all',
}));
